/* eslint-disable no-console */
import Translate from 'components/atoms/Translate';
import { transvoiceLog } from 'utils/miscUtil';
import { errorsReceive } from './actions';

const genericErrorResources = [
  'submitTimeReport',
  'updateWorkAssignmentExpenses',
  'rateWorkAssignment',
];

const convertError = error => {
  const sendError = {
    ErrorCode: error.response.status,
    ErrorMessage: error.message,
  };
  return sendError;
};

const getHandledError = (payload, resource) => {
  if (genericErrorResources.includes(resource)) {
    return {
      ErrorMessage: Translate({ content: 'timeReport.submitError' }),
    };
  }
  return { ...convertError(payload) };
};

const errorMiddleware = store => next => action => {
  const { payload, error, meta } = action;
  const resource = meta?.resource;

  if (error && payload) {
    if (Object.prototype.toString.call(payload) === '[object Error]' && payload.response) {
      transvoiceLog(error);
      store.dispatch(errorsReceive(getHandledError(payload, resource)));
    } else if (Object.prototype.toString.call(payload) !== '[object Error]') {
      if (genericErrorResources.includes(resource)) {
        store.dispatch(errorsReceive({
          ErrorMessage: Translate({ content: 'timeReport.submitError' }),
        }));
      } else {
        store.dispatch(errorsReceive({ ...payload }));
      }
    }
  }
  return next(action);
};

export default errorMiddleware;
